<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const reason1ImgSrc = cfgToThemeCdnPath("/about-vip/modern/welcome-bonus-reason1.png");
const rows = [
	{
		label: Verbiage.vip_modern_players_wanting_higher_risk_and_reward,
		active: false
	},
	{
		label: Verbiage.vip_modern_bigger_bonus_bigger_requirement,
		active: false
	},
	{
		label: Verbiage.vip_modern_wager_it_into_real_cash,
		active: true
	}
];
</script>

<section class="vip-welcome-bonus">
	<VipModernEyebrow text={$t(Verbiage.vip_modern_welcome_bonus_tag)} />

	<Text
		type="title"
		titleSize="h4"
		titleWeight="bold"
		textColor="white"
		textAlign={$isMobile ? 'start' : 'center'}
		className="vip-welcome-bonus-title"
	>
		{$t(Verbiage.vip_modern_welcome_bonus_title)}
	</Text>

	<div class="vip-welcome-bonus-grid">
		<InfoCard
			modernStyle
			modernGlowPosition="left"
			noPadding
			borderRadius="8px"
			customClass="vip-welcome-bonus-card vip-welcome-bonus-card-reason1"
		>
			<div class="vip-welcome-bonus-card-inner">
				<span class="vip-welcome-bonus-badge">
					<span class="vip-welcome-bonus-badge-dot"></span>
					{$t(Verbiage.vip_modern_reason_one)}
				</span>

				<Text type="title" titleSize="h6" titleWeight="bold" textColor="white">
					{$t(Verbiage.vip_modern_why_the_requirement_exists)}
				</Text>

				<Text type="body" bodySize="small" textColor="gray">
					{$t(Verbiage.vip_modern_welcome_bonus_reason1_body)}
				</Text>

				<img
					class="vip-welcome-bonus-reason1-img"
					src={reason1ImgSrc}
					alt={$t(Verbiage.illustration_alt, 'alts')}
				/>
			</div>
		</InfoCard>

		<InfoCard
			modernStyle
			modernNoGlow
			noPadding
			borderRadius="8px"
			customClass="vip-welcome-bonus-card vip-welcome-bonus-card-reason2"
		>
			<div class="vip-welcome-bonus-card-inner">
				<span class="vip-welcome-bonus-badge">
					<span class="vip-welcome-bonus-badge-dot"></span>
					{$t(Verbiage.vip_modern_reason_two)}
				</span>

				<Text type="title" titleSize="h6" titleWeight="bold" textColor="white">
					{$t(Verbiage.vip_modern_why_some_players_choose_it_anyway)}
				</Text>

				<Text type="body" bodySize="small" textColor="gray">
					{$t(Verbiage.vip_modern_welcome_bonus_reason2_body)}
				</Text>

				<div class="vip-welcome-bonus-rows">
					{#each rows as row (row.label)}
						<div class="vip-welcome-bonus-row" class:active={row.active}>
							<Text type="body" bodySize="small" bodyWeight="semibold" textColor="white">
								{$t(row.label)}
							</Text>
							<span class="vip-welcome-bonus-row-dots">•••</span>
						</div>
					{/each}
				</div>
			</div>
		</InfoCard>
	</div>
</section>

<style>
	.vip-welcome-bonus {

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: flex-start;

		gap: 1.25rem;

		text-align: left
}

	:global(.vip-welcome-bonus-title) {

		max-width: 40rem;

		font-size: 32px !important
}

	.vip-welcome-bonus-grid {

		margin-top: 1.5rem;

		display: grid;

		width: 100%;

		grid-template-columns: repeat(1, minmax(0, 1fr));

		gap: 1rem
}

	:global(.vip-welcome-bonus-card) {

		width: 100%
}

	.vip-welcome-bonus-card-inner {

		position: relative;

		display: flex;

		min-height: 220px;

		flex-direction: column;

		align-items: flex-start;

		gap: 0.75rem;

		padding: 1.25rem;

		text-align: left
}

	.vip-welcome-bonus-badge {

		display: inline-flex;

		align-items: center;

		gap: 0.5rem;

		white-space: nowrap;

		font-size: 0.75rem;

		line-height: 1rem;

		font-weight: 700;

		text-transform: uppercase;

		letter-spacing: 0.025em;

		background-color: rgb(255 255 255 / 0.05);

		color: var(--color-primary-300);

		border-radius: 9999px;

		padding-left: 0.75rem;

		padding-right: 0.75rem;

		padding-top: 0.375rem;

		padding-bottom: 0.375rem
}

	.vip-welcome-bonus-badge-dot {

		display: block;

		height: 0.375rem;

		width: 0.375rem;

		border-radius: 9999px;

		background-color: var(--color-primary-300)
}

	.vip-welcome-bonus-reason1-img {

		margin-top: 0.5rem;

		height: auto;

		width: 100%;

		-o-object-fit: contain;

		   object-fit: contain
}

	.vip-welcome-bonus-rows {

		margin-top: 0.5rem;

		display: flex;

		width: 100%;

		flex-direction: column;

		overflow: hidden;

		border-radius: 0.5rem
}

	.vip-welcome-bonus-row {

		position: relative;

		display: flex;

		width: 100%;

		align-items: center;

		justify-content: space-between;

		gap: 0.75rem;

		padding-left: 1rem;

		padding-right: 1rem;

		padding-top: 0.75rem;

		padding-bottom: 0.75rem;

		background-color: var(--color-primary-900)
}

	.vip-welcome-bonus-row:nth-child(2) {

		background-color: var(--color-primary-700)
}

	.vip-welcome-bonus-row.active {

		z-index: 1;

		background-color: var(--color-primary-500);

		--tw-shadow: 0 0 16px 2px var(--color-primary-500);

		--tw-shadow-colored: 0 0 16px 2px var(--tw-shadow-color);

		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

	.vip-welcome-bonus-row-dots {

		letter-spacing: 0.1em;

		color: rgb(255 255 255 / 0.6)
}

	@media (min-width: 1024px) {
		.vip-welcome-bonus-grid {

				grid-template-columns: repeat(2, minmax(0, 1fr))
		}
	}
</style>
